new Vue({
    el: '#currency-calculator',
    data: {
        currencies: [],

        selectedAmount: 0,
        calcualtedAmount: 0,

        selectedFirstCurrency: null,
        selectedSecondCurrency: null,

        multiplier: null,

        defaultCurrencySymbol: 'GEL',
        defaultCurrency: null,

        isSubmited: false,
        result: false,
        resultMessage: null,
        sendingData: false,
    },
    methods: {
        calculate: function (e) {
            var _this = this;
            if (!!_this.selectedFirstCurrency) {
                if (_this.selectedFirstCurrency.title == _this.defaultCurrencySymbol) {
                    _this.calcualtedAmount = (_this.selectedAmount / _this.multiplier).toFixed(4);
                } else {
                    _this.calcualtedAmount = (_this.selectedAmount * _this.multiplier);//.toFixed(4);
                }
            }
        }
    },
    watch: {
        'selectedAmount': function (newVal, oldVal) {
            var _this = this;
            _this.calculate();
        },
        'selectedFirstCurrency': function (newVal, oldVal) {
            var _this = this;
            if (oldVal == null) {
                return;
            }
            if (newVal.title != _this.defaultCurrencySymbol) {
                _this.selectedSecondCurrency = _this.currencies.find(r => r.title == _this.defaultCurrencySymbol);
                _this.multiplier = _this.selectedFirstCurrency.buy;
            }
            else if (newVal.title == _this.defaultCurrencySymbol && _this.selectedSecondCurrency.title == _this.defaultCurrencySymbol) {
                _this.selectedSecondCurrency = oldVal;
                _this.multiplier = _this.selectedSecondCurrency.buy;
            }
            _this.calculate();
        },
        'selectedSecondCurrency': function (newVal, oldVal) {
            var _this = this;
            if (oldVal == null) {
                return;
            }
            if (newVal.title != _this.defaultCurrencySymbol) {
                _this.selectedFirstCurrency = _this.currencies.find(r => r.title == _this.defaultCurrencySymbol);
                _this.multiplier = _this.selectedSecondCurrency.sell;
            }
            else if (newVal.title == _this.defaultCurrencySymbol && _this.selectedFirstCurrency.title == _this.defaultCurrencySymbol) {
                _this.selectedFirstCurrency = oldVal;
                _this.multiplier = _this.selectedFirstCurrency.sell;
            }
            _this.calculate();
        }
    },
    mounted: function () {
        var _this = this;
        if (!!window.currencies) {
            _this.currencies = window.currencies;
            _this.defaultCurrency = _this.currencies.find(r => r.title == _this.defaultCurrencySymbol);

            _this.selectedFirstCurrency = _this.currencies.find(r => r.title != _this.defaultCurrencySymbol);
            _this.selectedSecondCurrency = _this.defaultCurrency;

            _this.selectedAmount = 100;
            _this.calculate();
            _this.multiplier = _this.selectedFirstCurrency.buy;
            //_this.calcualtedAmount = _this.selectedAmount * _this.selectedFirstCurrency.sell;
        }
    }
    //computed: {
    //    calcualtedAmount: function () {
    //        var _this = this;
    //        if (!!_this.selectedFirstCurrency) {
    //            return _this.selectedAmount * _this.selectedFirstCurrency.buy;
    //        }
    //    }
    //}
})